import React from "react";
import { ReactComponent as LightBulb } from "svgs/light-bulb.svg";
import clsx from "clsx";

const ButtonSwitch = ({ dynamicFeature, activeFeature, onFeatureSelect, defaultValue }) => {
	const [activeKey, activeDisplay] = (activeFeature || defaultValue).split("=");
	const displayValue = activeDisplay || activeKey;

	// Toggle the feature value
	const toggleFeature = () => {
		const newFeature = dynamicFeature.values.find((value) => {
			const [key] = value.split("=");
			return key !== activeKey;
		});
		onFeatureSelect(newFeature);
	};

	return (
		<div className={clsx(
			"absolute top-5 left-4 md:top-0 z-10 bg-white w-28  border-beige border")}>
			<button
				className={clsx(
					"p-2 flex text-xs items-center gap-2 text-dimGray w-full bg-lightBeige",
					displayValue === "OFF" && "!bg-iceMist border-iceMist"
				)}
				onClick={toggleFeature}
			>
				<span className="size-4">
					<LightBulb />
				</span>
				<span className="text-xs">
					{dynamicFeature.key.split("=")[1] || dynamicFeature.key.split("=")[0]}:
					<span className="pl-1 font-bold text-black">{displayValue}</span>
				</span>
			</button>
		</div>
	);
};

export default ButtonSwitch;